import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8e6de9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "portfolio",
  id: "portfolio"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Portfolio", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Nuestro portafolio incluye una amplia variedad de proyectos realizados con éxito. Aquí puede ver algunos ejemplos de nuestro trabajo:", -1))
const _hoisted_5 = { class: "portfolio__images" }
const _hoisted_6 = { class: "portfolio__images__full" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "portfolio__images__col" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Estamos orgullosos de ofrecer servicios de alta calidad y cumplir con los más altos estándares de seguridad y eficiencia en cada uno de nuestros proyectos. Si está interesado en contratar nuestros servicios, no dude en ponerse en contacto con nosotros. Estaremos encantados de ayudarle.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            src: require('@/assets/images/bobinados_portfolio.png'),
            alt: ""
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("img", {
            src: require('@/assets/images/portones_portfolio.png'),
            alt: ""
          }, null, 8, _hoisted_9),
          _createElementVNode("img", {
            src: require('@/assets/images/instalaciones_portfolio.png'),
            alt: ""
          }, null, 8, _hoisted_10)
        ])
      ]),
      _hoisted_11,
      _createVNode(_component_Button, {
        text: 'Contacto',
        disable: false,
        link: '#contact'
      })
    ])
  ]))
}